// src/components/AdminPage.js
import React, { useState, useEffect, useContext } from 'react';
import { db } from '../firebaseConfig';
import { collection, query, where, onSnapshot, doc, updateDoc } from 'firebase/firestore';
import { AuthContext } from '../App';

// --- Basic Styling (similar to others, you'd centralize these) ---
const adminPageStyles = {
    padding: '20px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    maxWidth: '700px',
    margin: '20px auto',
    boxShadow: '0 2px 4px rgba(0,0-0,0.1)',
};

const userCardStyles = {
    border: '1px solid #eee',
    padding: '15px',
    marginBottom: '10px',
    borderRadius: '5px',
    backgroundColor: '#f9f9f9',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
};

const userDetailsStyles = {
    flexGrow: 1,
    minWidth: '250px',
    marginBottom: '10px',
};

const buttonStyles = {
    padding: '8px 12px',
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
    backgroundColor: '#007bff',
    color: 'white',
    fontSize: '0.9em',
    marginLeft: '10px',
};

const approveButtonStyles = {
    ...buttonStyles,
    backgroundColor: '#28a745', // Green for approve
};

const denyButtonStyles = { // NEW: Style for Deny button
    ...buttonStyles,
    backgroundColor: '#ffc107', // Amber/Orange for deny
    color: '#343a40', // Dark text for contrast
};

const logoutButtonStyles = {
    padding: '10px 15px',
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
    backgroundColor: '#dc3545', // Red for logout
    color: 'white',
    fontSize: '1em',
    marginTop: '20px',
};


export default function AdminPage() {
    const [pendingUsers, setPendingUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('');
    const { currentUser, logout } = useContext(AuthContext);

    // Real-time listener for pending users
    useEffect(() => {
        if (!currentUser) return;

        setLoading(true);
        const q = query(
            collection(db, 'personnel'),
            where('status', '==', 'pending_approval')
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const usersData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setPendingUsers(usersData);
            setLoading(false);
        }, (error) => {
            console.error("Error fetching pending users:", error);
            setMessage(`Error fetching pending users: ${error.message}`);
            setLoading(false);
        });

        return unsubscribe;
    }, [currentUser]);

    const handleApproveUser = async (uid) => {
        if (!window.confirm(`Are you sure you want to approve user ${uid}?`)) {
            return;
        }
        try {
            const userRef = doc(db, 'personnel', uid);
            await updateDoc(userRef, {
                status: 'approved',
                roles: ['approved_user'] // Assign default approved role
            });
            setMessage(`User ${uid} approved successfully!`);
        } catch (error) {
            console.error("Error approving user:", error);
            setMessage(`Error approving user ${uid}: ${error.message}`);
        }
        setTimeout(() => setMessage(''), 3000);
    };

    // NEW: Function to handle denying a user
    const handleDenyUser = async (uid) => {
        if (!window.confirm(`Are you sure you want to DENY user ${uid}? Their account will be deactivated.`)) {
            return;
        }
        try {
            const userRef = doc(db, 'personnel', uid);
            await updateDoc(userRef, {
                status: 'denied', // Set status to 'denied'
                roles: ['denied'] // Assign 'denied' role, or an empty array []
            });
            setMessage(`User ${uid} denied successfully!`);
        } catch (error) {
            console.error("Error denying user:", error);
            setMessage(`Error denying user ${uid}: ${error.message}`);
        }
        setTimeout(() => setMessage(''), 3000);
    };


    return (
        <div style={adminPageStyles}>
            <h1>Admin Panel - User Approvals</h1>
            <p>Welcome, Administrator ({currentUser?.email})!</p>

            {message && (
                <div style={{...adminPageStyles, backgroundColor: '#e6ffe6', borderColor: '#b3ffb3', color: '#1a7a1a', margin: '10px 0', padding: '10px'}}>
                    {message}
                </div>
            )}

            <h2>Pending Registrations</h2>
            {loading ? (
                <p>Loading pending users...</p>
            ) : pendingUsers.length === 0 ? (
                <p>No pending users to approve.</p>
            ) : (
                <div>
                    {pendingUsers.map(user => (
                        <div key={user.id} style={userCardStyles}>
                            <div style={userDetailsStyles}>
                                <strong>Email:</strong> {user.email}<br/>
                                <strong>Full Name:</strong> {user.fullName}<br/>
                                <strong>Department:</strong> {user.department}<br/>
                                <strong>Position:</strong> {user.position}<br/>
                                <strong>UID:</strong> <code>{user.id}</code>
                            </div>
                            <div>
                                <button
                                    onClick={() => handleApproveUser(user.id)}
                                    style={approveButtonStyles}
                                >
                                    Approve
                                </button>
                                {/* NEW: Deny button */}
                                <button
                                    onClick={() => handleDenyUser(user.id)}
                                    style={denyButtonStyles}
                                >
                                    Deny
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
            <button onClick={logout} style={logoutButtonStyles}>Log Out</button>
        </div>
    );
}